import React from "react";
import InfoCard from "@/components/InfoCard";
import { InfoCardData } from "@/hooks/useHomePageData";

interface KienTaoSectionProps {
  cards: InfoCardData[];
}

const KienTaoSection: React.FC<KienTaoSectionProps> = ({ cards }) => {
  return (
    <div className="flex flex-col gap-3 md:gap-4 mt-12 md:mt-14 mb-12 md:mb-14">
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-medium text-black">Vai trò của Kiến Tạo</h1>
      {cards.map((card) => (
        <InfoCard
          key={card.id}
          title={card.title}
          description={card.description}
          image={card.image}
          className={card.className}
          localImage={true}
        />
      ))}
    </div>
  );
};

export default KienTaoSection;
